// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__mf4TB","email-form-container":"Footer_email-form-container__ZdlKV","email-form":"Footer_email-form__+LYj4","email-text":"Footer_email-text__5dMjo"};